<div class="iti iti--allow-dropdown" [ngClass]="separateDialCodeClass">
  <div class="iti__country-container" dropdown [ngClass]="{ disabled: disabled }" [isDisabled]="disabled">
    <div class="iti__selected-country dropdown-toggle" dropdownToggle>
      <div class="iti__flag" [ngClass]="selectedCountry.flagClass || ''"></div>
      @if (separateDialCode) {
        <div class="selected-dial-code">+{{ selectedCountry.dialCode }}</div>
      }
      <div class="iti__arrow"></div>
    </div>
    <div *dropdownMenu class="dropdown-menu country-dropdown iti--inline-dropdown iti--flexible-dropdown-width">
      <ul class="iti__country-list" #countryList>
        @for (country of preferredCountriesInDropDown; track country.iso2) {
          <li
            class="iti__country iti__preferred"
            (click)="onCountrySelect(country, focusable)"
            [id]="country.htmlId + '-preferred'"
          >
            <div class="iti__flag-box">
              <div class="iti__flag" [ngClass]="country.flagClass"></div>
            </div>
            <span class="iti__country-name">{{ country.name }}</span>
            <span class="iti__dial-code">+{{ country.dialCode }}</span>
          </li>
        }
        @if (preferredCountriesInDropDown?.length) {
          <li class="iti__divider"></li>
        }
        @for (country of allCountries; track country.iso2) {
          <li class="iti__country iti__standard" (click)="onCountrySelect(country, focusable)" [id]="country.htmlId">
            <div class="iti__flag-box">
              <div class="iti__flag" [ngClass]="country.flagClass"></div>
            </div>
            <span class="iti__country-name">{{ country.name }}</span>
            <span class="iti__dial-code">+{{ country.dialCode }}</span>
          </li>
        }
      </ul>
    </div>
  </div>
  <input
    type="tel"
    [id]="inputId"
    autocomplete="off"
    [ngClass]="cssClass"
    (blur)="onTouched()"
    (keypress)="onInputKeyPress($event)"
    [(ngModel)]="phoneNumber"
    (ngModelChange)="onPhoneNumberChange()"
    [disabled]="disabled"
    [placeholder]="resolvePlaceholder()"
    [attr.maxLength]="maxLength"
    [attr.validation]="phoneValidation"
    class="iti__tel-input"
    #focusable
  />
</div>
